import { render, staticRenderFns } from "./BottomRight.vue?vue&type=template&id=f82bb7ec&scoped=true&"
import script from "./BottomRight.vue?vue&type=script&lang=js&"
export * from "./BottomRight.vue?vue&type=script&lang=js&"
import style0 from "./BottomRight.vue?vue&type=style&index=0&id=f82bb7ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82bb7ec",
  null
  
)

export default component.exports